import React, { useContext } from 'react';
import { Grid, Button } from "@material-ui/core/";
import { Add } from '@material-ui/icons';

import Paginacao from '../../../../../../../../../util/paginacao/.mixins/paginacao';
import { CardFichaTecnica } from "../../../../../../../../../util/CardFichaTecnica/.mixins";
import OpcoesBuscaPopoverAllFilter from '../../../../../../../../../util/opcoesBuscaPopoverAllFilters/.mixins';
import SearchField from '../../../../../../../../../util/searchPedido/.mixins';
import Status from "../../../../../../../../../util/status/.mixins";
import { AuthContext } from '../../../../../../../../../../contexts/AuthContext';

//css
import StylesCss from './styles';
const useStyles = StylesCss();

export default ({
    state: {
        searchFieldAcessorios,
        searchFieldExternalAcessorios,
        colunasAcessorios,
        colunasFilterTagsAcessorios,
        opcoesFilial,
        opcoesFiltroPedidos,
        dataAcessorios,
        dataAcessoriosSelected,
        escolhaSituacaoAcessorios,
        opcoesSituacoes,
        statusAcessorios,
        firstLoad,
        opcoesGrupos,
        opcoesFamilias,
        escolhaGrupo,
        escolhaFamilia,
        isSelectFamiliasAcessoriosDisabled,
        rowsPerPageAcessorios,
        totalRowsAcessorios,
    },
    handlerCleanFiltersAcessorios,
    handlerAplicarFiltersAcessorios,
    handlerClearFilterTagAcessorios,
    handlerSelectCheckboxAcessorios,
    handlerClickCheckboxAcessorios,
    disableSelectFamiliasAcessorios,

    handlerChangeSituacoesAcessorios,
    handlerCheckboxAllAcessorios,
    handleChangeGruposAcessorios,
    handleChangeFamiliasAcessorios,

    handlerChangeSearchFieldAcessorios,
    handlerChangeSearchFieldExternalAcessorios,
    handlerClickSearchFieldExternalAcessorios,

    onChangePageAcessorios,
    onClickViewModalAcessorios,
    onUpFileAcessorios,

    childAlert
}) => {
    const classes = useStyles();
    const { user: { isVisaoTok } } = useContext(AuthContext);

    const listaCard = dataAcessorios.map((element, i) =>

        <div key={i}>
            <Grid container spacing={2}>
                {/* <Grid item xs={1} className={classes.checkboxCenter}>
                    <Checkbox
                        checked={
                            (dataAcessoriosSelected.filter(e=>(JSON.stringify(e))==(JSON.stringify(element)))).length > 0
                        }
                        onChange={()=>{handlerSelectCheckboxAcessorios(element)}}
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                </Grid> */}
                <Grid item xs={12}>
                    <CardFichaTecnica
                        tipo_card="a"
                        pdf_link={element.pdfLink}
                        atributos={{
                            alfa: element.alfaNumerico,
                            nome_produto: element.nomeProduto,
                            id_produto: element.idsProduto,
                            departamento: element.departamento,
                            linha: element.linha,
                            grupo: element.grupo,
                            nome_fornecedor: element.nm_fornecedor,
                            status: element.status,
                            idDescr: element.idDescr,
                            dt_atlz: element.dt_atlz,
                        }}
                        produtos={element.produtos}
                        upload_file={() => { onUpFileAcessorios(element) }}
                        onClickViewModal={onClickViewModalAcessorios}
                        childAlert
                    />
                </Grid>
            </Grid>
        </div>
    );

    const handleAdicionarFichaTecnicaRouter = () => {
        window.location.href = '../#/qualidade/adicionar-ficha-tecnica'
    }

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} className={classes.flexSeach}>
                    <SearchField
                        searchField={searchFieldExternalAcessorios}
                        handleChangeSearchFieldPedido={handlerChangeSearchFieldExternalAcessorios}
                        handleClickSearchField={handlerClickSearchFieldExternalAcessorios}
                        label="Pesquisar Alfa Numérico"
                    />
                    {isVisaoTok &&
                        <Button startIcon={<Add />} size="small" variant="text" color="primary" onClick={handleAdicionarFichaTecnicaRouter}>
                            Adicionar ficha técnica de acessórios
                        </Button>
                    }
                </Grid>
                <Grid item xs={4}>
                    <OpcoesBuscaPopoverAllFilter
                        searchBarTitle="Produto"
                        searchField={searchFieldAcessorios}
                        isColunasMultiple={true}

                        colunas={colunasAcessorios}
                        colunasFilterTags={colunasFilterTagsAcessorios}
                        opcoesFilial={opcoesFilial}
                        opcoesFiltroPedidos={opcoesFiltroPedidos}
                        escolhaSituacao={escolhaSituacaoAcessorios}
                        opcoesSituacoes={opcoesSituacoes}
                        opcoesGrupos={opcoesGrupos}
                        opcoesFamilias={opcoesFamilias}
                        escolhaGrupo={escolhaGrupo}
                        escolhaFamilia={escolhaFamilia}
                        isSelectFamiliasDisabled={isSelectFamiliasAcessoriosDisabled}
                        disableSelectFamilias={disableSelectFamiliasAcessorios}

                        handleChangeGrupos={handleChangeGruposAcessorios}
                        handleChangeFamilias={handleChangeFamiliasAcessorios}
                        handlerChangeSituacoes={handlerChangeSituacoesAcessorios}
                        handlerCleanFilters={handlerCleanFiltersAcessorios}
                        handlerAplicarFilters={handlerAplicarFiltersAcessorios}
                        handlerClearFilterTag={handlerClearFilterTagAcessorios}
                        handleChangeSearchFieldPedido={handlerChangeSearchFieldAcessorios}
                        handlerClickCheckbox={handlerClickCheckboxAcessorios}
                    />
                </Grid>
                <Grid item xs={4}></Grid>
                <Grid item xs={4}>
                    {/* <Status
                        status={statusAcessorios}
                        handleChangeStatus={handlerChangeStatusAcessorios}
                    /> */}
                </Grid>
            </Grid>
            {totalRowsAcessorios > 0 &&
                <>
                    <Grid container spacing={2}>
                        {/* <Grid item xs={1}>
                            <Checkbox
                                className={classes.checkboxCenter}
                                checked={totalRowsAcessorios==dataAcessoriosSelected.length}
                                onChange={handlerCheckboxAllAcessorios}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                            />
                        </Grid> */}
                        <Grid item xs={12}></Grid>
                    </Grid>
                    {listaCard}
                    <Paginacao
                        rowsPerPage={rowsPerPageAcessorios}
                        totalRows={totalRowsAcessorios}
                        onChangePage={onChangePageAcessorios}
                        firstLoad={firstLoad}
                    />
                </>
            }
            {totalRowsAcessorios == 0 &&
                <div align={"center"}>
                    Não existem registros!
                </div>
            }
        </>
    );
};
